// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.2.4 | MIT License | https://tailwindcss.com */
.sidebar {
  transition: width 0.3s ease;
  @media (width >= 48rem) {
    width: 150px;
  }
  @media (width >= 64rem) {
    width: 300px;
  }
}
.sidebar.sidebar-collapsed {
  width: calc(var(--spacing, 0.25rem) * 7) !important;
}
.sidebar-collapsed .sidebar-title {
  justify-content: center;
}`, "",{"version":3,"sources":["<no source>","webpack://./app/Components/Forms/container/sidebar/sidebar.component.css"],"names":[],"mappings":"AAAA,iEAAA;ACEA;EACI,2BAA4B;EACrB;IAAA,YAAY;EAAA;EAAC;IAAA,YAAY;EAAA;AACnC;AAED;EACW,mDAAI;AACd;AAED;EACI,uBAAwB;AAC3B","sourcesContent":[null,"@reference '../../../../assets/css/main.css';\r\n\r\n.sidebar {\r\n    transition: width 0.3s ease;\r\n    @apply md:w-[150px] lg:w-[300px]\r\n}\r\n\r\n.sidebar.sidebar-collapsed {\r\n    @apply w-7!;\r\n}\r\n\r\n.sidebar-collapsed .sidebar-title {\r\n    justify-content: center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
